import { FinanceFinancialWorkspacePaceDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { useSeePayrollLanding } from 'modules/finance/components/FinancialWorkspacePayroll/hooks/useSeePayrollLanding'

export const useFinancialWorkspacePage = () => {
  const { data, loading, error } = useQuery(FinanceFinancialWorkspacePaceDocument)

  const { seePayrollLanding, loading: seePayrollLandingLoading } = useSeePayrollLanding()
  const canSeeFinanceWorkspace = data?.financialWorkspace._policies.seeFinancialWorkspace.can
  const canSeeFinanceWorkspacePayroll =
    data?.financialWorkspace?._policies?.payrollSee?.can ?? false
  const canSeeFinanceWorkspaceCompensations =
    data?.financialWorkspace?._policies?.compensationsSee?.can ?? false
  const canAccessOverview =
    data?.finance._policies.sidebarSeeFinanceOverviewSubLevelItem?.can ?? false
  const canSeeAllCompanyData = data?.financialWorkspace?._policies?.seeAllCompanyData?.can ?? false

  return {
    canSeeFinanceWorkspace,
    canSeeFinanceWorkspacePayroll,
    canAccessOverview,
    canSeeAllCompanyData,
    canSeeFinanceWorkspaceCompensations,
    seePayrollLanding,
    loading: loading || seePayrollLandingLoading,
    error,
  }
}
